module.exports = __webpack_public_path__ + "img/slide_003_g.6144a4e9.jpg";